import { displayFunctions } from '../../utils/chartsUtils';

export const data = {
  plots: {
    post_reach: {
      facebook: {
        trend: 1,
        values: [10, 15, 8, 29, 10, 11, 17],
        displayValue: displayFunctions.sum([10, 15, 8, 29, 10, 11, 17])
      },
      instagram: {
        trend: 1,
        values: [10, 20, 20, 25, 17, 19, 22],
        displayValue: displayFunctions.sum([10, 20, 20, 25, 17, 19, 22])
      }
    },
    profile_followers: {
      facebook: {
        trend: 0,
        values: [170, 174, 174, 174, 180, 183, 183],
        displayValue: 183
      },
      instagram: {
        trend: 0,
        values: [180, 180, 182, 175, 176, 180, 187],
        displayValue: 187
      },
      twitter: {
        trend: 8,
        values: [226, 226, 226, 226, 220, 230, 230],
        displayValue: 230
      },
      linkedin_business_page: {
        trend: 0,
        values: [154, 154, 160, 162, 162, 163, 152],
        displayValue: 152
      }
    },

    post_reactions: {
      facebook: {
        trend: 0,
        values: [11, 3, 0, 0, 14, 4, 10],
        displayValue: displayFunctions.sum([11, 3, 0, 0, 14, 4, 10])
      },
      instagram: {
        trend: 0,
        values: [0, 1, 1, 2, 10, 7, 15],
        displayValue: displayFunctions.sum([0, 1, 1, 2, 10, 7, 15])
      },
      twitter: {
        trend: 8,
        values: [2, 0, 5, 0, 2, 4, 8],
        displayValue: displayFunctions.sum([2, 0, 5, 0, 2, 4, 8])
      },
      linkedin_personal_account: {
        trend: 0,
        values: [0, 0, 9, 0, 0, 0, 7],
        displayValue: displayFunctions.sum([0, 0, 9, 0, 0, 0, 7])
      },
      linkedin_business_page: {
        trend: 0,
        values: [0, 3, 0, 9, 0, 1, 7],
        displayValue: displayFunctions.sum([0, 3, 0, 9, 0, 1, 7])
      }
    },
    overview: {
      impressions: {
        trend: 1,
        values: [30, 50, 0, 35, 35, 130, 150],
        displayValue: displayFunctions.sum([30, 50, 0, 35, 35, 130, 150])
      },
      reach: {
        trend: 1,
        values: [33, 43, 66, 51, 44, 56, 50],
        displayValue: displayFunctions.sum([33, 43, 66, 51, 44, 56, 50])
      },
      reactions: {
        trend: 0,
        values: [22, 23, 20, 0, 22, 1, 34],
        displayValue: displayFunctions.sum([22, 23, 20, 0, 22, 1, 34])
      }
    },
    post_impressions: {
      instagram: {
        trend: 1,
        values: [0, 0, 10, 0, 0, 45, 50],
        displayValue: displayFunctions.sum([0, 0, 10, 0, 0, 45, 50])
      },
      linkedin_business_page: {
        trend: 1,
        values: [0, 40, 0, 110, 0, 20, 30],
        displayValue: displayFunctions.sum([0, 40, 0, 110, 0, 20, 30])
      },
      facebook: {
        trend: 1,
        values: [15, 5, 3, 0, 50, 35, 44],
        displayValue: displayFunctions.sum([15, 5, 3, 0, 50, 35, 44])
      }
    },
    profile_views: {
      instagram: {
        trend: 1,
        values: [7, 3, 10, 9, 8, 16, 5],
        displayValue: displayFunctions.sum([7, 3, 10, 9, 8, 16, 5])
      },
      google: {
        trend: 0,
        values: [1, 4, 2, 5, 3, 1, 2],
        displayValue: displayFunctions.sum([1, 4, 2, 5, 3, 1, 2])
      },
      linkedin_business_page: {
        trend: 0,
        values: [16, 0, 0, 0, 0, 4, 20],
        displayValue: displayFunctions.sum([16, 0, 0, 0, 0, 4, 20])
      }
    },
    posts_per_day_plot: {
      posts_per_day_plot: {
        trend: 1,
        values: [1, 1, 0, 1, 4, 2, 1],
        displayValue: displayFunctions.sum([1, 1, 0, 1, 4, 2, 1])
      }
    }
  },
  additionalData: {
    posts_per_day: {
      trend: -1,
      values: [0, 0, 1, 0, 0, 2, 1],
      displayValue: 3
    }
  },
  dates: getLastSevenDays()
};

function getLastSevenDays() {
  const dates = [];
  for (let i = 1; i < 8; i++) {
    const date = new Date();
    date.setDate(date.getDate() - i);
    dates.push(date.toISOString().split('T')[0] + 'T00:00:00+00:00');
  }
  return dates.reverse();
}
